import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. Membership",
    body: "PrimeConnect is a private, invitation-only network for verified sales and lettings agents practising in prime residential markets. Membership is granted at our sole discretion following review of your application and agency credentials. We may suspend or revoke membership that breaches these terms or the confidentiality of the network.",
  },
  {
    title: "2. Acceptable use",
    body: "You may post property opportunities and client searches only where you hold a genuine instruction or client relationship. You must not scrape, reproduce, or disclose any content from the network to non-members, public portals, or search engines. All matches and commission splits are negotiated and agreed between member agencies; PrimeConnect is a venue, not a party to your transactions.",
  },
  {
    title: "3. Confidentiality",
    body: "Off-market listings, addresses, and client identities shared through the network are confidential. Full addresses and client details may only be disclosed after mutual acceptance and under the confidentiality terms recorded in-app.",
  },
  {
    title: "4. Commission arrangements",
    body: "Commission splits agreed in-app form a written record of the terms between the two agencies concerned. PrimeConnect does not handle, escrow, or guarantee payment of commissions.",
  },
  {
    title: "5. Liability",
    body: "The network is provided 'as is'. To the fullest extent permitted by law, PrimeConnect Ltd excludes liability for indirect or consequential loss arising from use of the network or from dealings between member agencies.",
  },
  {
    title: "6. Contact",
    body: "Questions about these terms: hello@primeconnect.network. PrimeConnect Ltd, London. These terms are governed by the laws of England and Wales.",
  },
];

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#FAF9F5] text-[#141518] py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6 sm:px-8">
        <Reveal>
          <Link
            to="/"
            data-testid="terms-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#635F57] hover:text-[#141518] transition-colors duration-300"
          >
            <ArrowLeft size={15} /> Back to PrimeConnect
          </Link>
          <p className="font-eyebrow text-[11px] text-[#928E84] mt-12">Legal</p>
          <h1 className="font-display font-medium tracking-tight text-4xl sm:text-5xl mt-4">
            Terms of Service
          </h1>
          <p className="text-sm text-[#928E84] mt-4">Last updated: July 2026</p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-2xl">{s.title}</h2>
              <p className="text-base text-[#635F57] leading-relaxed mt-4">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
